import { useMemo } from 'react'

import { SupportedLanguage, supportedLanguages } from '@common'

import { useLocale } from '../../../locale/useLocale'

type UseSmallerFontProps = {
  contentAmount: number
  size?: string
}

export const useSmallerFont = ({ contentAmount, size }: UseSmallerFontProps) => {
  return useMemo(() => {
    if (!size) {
      return contentAmount > Math.pow(10, 6)
    }
    return contentAmount > Math.pow(10, 6) && (size === 'size-bundle-sm' || size === 'size-product-page')
  }, [contentAmount, size])
}

export const useFormattedAmount = (amount: number) => {
  const locale = useLocale()
  return useMemo(() => formatAmount(amount, locale), [amount, locale])
}

export function formatAmount(amount: number, locale: SupportedLanguage) {
  if (amount <= 0) {
    return null
  }
  const language = supportedLanguages[locale]
  // TODO: remove the numberingSystem when it's merged to TS lib, included in 5.5.0-dev
  // https://github.com/microsoft/TypeScript/issues/52072
  const formatOptions: Intl.NumberFormatOptions & { numberingSystem: string } = {
    numberingSystem: 'latn',
  }

  if (language.rightToLeft) {
    const rtlAmount = new Intl.NumberFormat(language.locale, formatOptions).format(amount)
    return rtlAmount
  }

  // inserts a space before every group of three digits, starting from the end of the string
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
